export default __webpack_public_path__ + "static/media/TooMuchLeft.b7b17f54.svg";